<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('année de retraite')}">
					<label for="montant">Date estimée de votre départ en retraite</label>
					<custom-select :items="months" :selected="month" @change="month=$event"/>
					<input class="border-left" type="text" name="année de retraite" placeholder="Année de retraite" v-model="yearOfRetreat">
				</div>
				<div class="error-message"></div>
			</div>
			<div class="ctn-toggle row">
				<radio-box v-model="hasNotRetirement" />
				<div class="label">
					Je ne sais pas
				</div>
			</div>
			<div class="ctn-toggle row">
				<div class="label">
					Détenez vous des plans d'épargne retraites ?
				</div>
				<custom-toggle :value="isPERP" @change="isPERP=$event"/>
			</div>
			<div v-if="isPERP" class="ctn-tags row">
				<div class="tag" v-for="(perp, key) in PERPType" v-bind:key="key" :class="{active: isActiveTag(perp)}" @click="toggleTag(perp)">
					{{ perp }}
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import RadioBox from '@/common/components/Form/RadioBox'
import CustomSelect from '@/common/components/Form/CustomSelect'
import CustomToggle from '@/common/components/Form/CustomToggle'
import Months from '@/common/components/MyPatrimonialLandscape/data/Months'
import { mapGetters } from 'vuex'

export default {
	name: 'Retreat',
	components: {
		CustomSelect,
		CustomToggle,
		RadioBox
	},
	data () {
		return {
			month: Months[0],
			months: Months,
			yearOfRetreat: null,
			isPERP: false,
			PERPType: ['PERP', 'PERCO', 'Contrat TNS', 'Article 83', 'Autres'],
			activates: [],
			hasNotRetirement: false
		}
	},
	mounted () {
		this.month = this.estate.retreat.month || null
		this.yearOfRetreat = this.estate.retreat.year || null
		this.hasNotRetirement = !this.estate.retreat.hasRetirement || false
		this.activates = Array.from(this.estate.retreat.PERP) || []
		this.isPERP = (this.activates.length > 0)
	},
	methods: {
		toggleTag (value) {
			if (this.activates.indexOf(value) === -1) {
				this.activates.push(value)
			} else {
				this.activates.splice(this.activates.indexOf(value), 1)
			}
		},
		isActiveTag (value) {
			return (this.activates.indexOf(value) !== -1)
		},
		validate () {
			return new Promise((resolve, reject) => {
				resolve(true)
			})
		},
		save () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('storePatrimonial', {
					name: 'RETREAT',
					data: {
						month: this.month,
						year: this.yearOfRetreat,
						PERP: this.activates,
						hasRetirement: !this.hasNotRetirement
					},
					fromStart: false
				}).then(() => {
					resolve()
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	},
	watch: {
		hasNotRetirement (value) {
			if (value) {
				this.month = null
				this.yearOfRetreat = null
			}
		},
		isPERP (value) {
			if (!value) {
				this.activates = []
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.radio-box {
		margin-right: 0.5rem;
	}
</style>



// WEBPACK FOOTER //
// Retreat.vue?0bdcf001